export default function (i18nString: string, values: any) {
  for (const variable in values) {
    i18nString = i18nString.replace(new RegExp('{' + variable + '}', 'g'), values[variable])
  }
  return i18nString
}
